<template>
  <article 
  v-if="shouldShowRudiment"
  class="bg-gray-200 rounded p-4"
  >
    <NuxtLink :to="rudimentPath">
      <img
      v-if="rudimentData.image"
      :src="'https://media.drumrudiments.app/'+rudimentData.image.id+'/'+rudimentData.image.filename_download"
      :height="rudimentData.image.height"
      :width="rudimentData.image.width"
      :alt="rudimentData.image.description || rudimentData.title + ' | Drum Rudiments'"
      class="rounded border rounded-xl"
      />
    </NuxtLink>
    <div class="bg-gray-200 rounded-xl mt-3">
      <NuxtLink :to="rudimentPath">
        <h1 class="text-black text-xl font-semibold leading-6 tracking-tight">
          {{ rudimentData.title }}
        </h1>
      </NuxtLink>
      <div 
      class="flex gap-[3px] mt-3" 
      v-if="rudimentCategories?.length"
      >
        <NuxtLink 
        v-for="tag in rudimentCategories" 
        :key="tag.rudiment_categories?.slug"
        :to="getCategoryPath(tag)"
        class="btn--cat text-[11px] pb-[3px] pt-[2px] px-[6px]"
        >
          {{ tag.rudiment_categories?.title }}
        </NuxtLink>
      </div>
    </div>
  </article>
</template>

<script setup>
const config = useRuntimeConfig()
const user = useSupabaseUser()
const allowedStatus = config.public.postStatus?.split(',') || []

const props = defineProps({
  rudiment: {
    type: Object,
    required: true
  },
  play: {
    type: Boolean,
    required: false,
    default: true
  },
  type: {
    type: String,
    required: false,
    default: 'regular', // 'regular', 'category', 'collection', 'favourite'
    validator: (value) => ['regular', 'category', 'collection', 'favourite'].includes(value)
  }
})

const path = computed(() => props.play || user.value ? '/play/rudiment' : '/rudiment')
const explorePath = computed(() => props.play || user.value ? '/play/explore' : '/explore')

const rudimentData = computed(() => {
  if (props.type === 'regular') {
    return props.rudiment
  }
  return props.rudiment.rudiments
})

const rudimentCategories = computed(() => 
  rudimentData.value?.rudiments_rudiment_categories || []
)

const shouldShowRudiment = computed(() => {
  const hasRequiredFields = rudimentData.value?.title && rudimentData.value?.slug
  const statusCheck = props.type === 'regular' 
    ? (allowedStatus.includes(rudimentData.value?.status) || !rudimentData.value?.status)
    : allowedStatus.includes(rudimentData.value?.status)
  
  return hasRequiredFields && (props.type === 'collection' || statusCheck)
})

const rudimentPath = computed(() => 
  `${path.value}/${rudimentData.value.slug}`
)

const getCategoryPath = (tag) => `${explorePath.value}?category=${tag.rudiment_categories?.slug}`
</script>